<template>
  <div id="page-markup">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <h3 class="p-0">
        <b-icon class="mr-3" icon="percent" font-scale="1.5" variant="primary"></b-icon>
        {{ $t('pages.markupGlobal.title') }}
      </h3>
      <div>
        <button class="btn btn-small btn-success" v-on:click="editMode" v-if="!editModeActive">
          <b-icon class="" icon="pencil-square" font-scale="1" variant="white" ></b-icon>
          <span class="ml-2">{{ $t('common.actions.edit') }}</span>
        </button>
        <button class="btn btn-outline-primary mb-3 router-link-active" v-on:click="cancelEditMode" v-if="editModeActive">
          {{ $t('common.back') }}
        </button>
      </div>
    </div>

    <hr />

    <div class="col-12 col-md-12 col-lg-12 col-xl-6 p-0">
      <h4 class="">{{ $t('pages.markupGlobal.title') }}</h4>
      <hr />

      <div class="card shadow">
        <div class="card-body">
          <div class="app-color-text pt-3">
            <label class="font-weight-bold" for="globalMarkup">{{ $t('pages.markupGlobal.label') }} : </label><br />
            <span v-if="!editModeActive">
              {{ (configEnv && Number(configEnv.globalMarkup)) ? configEnv.globalMarkup + ' %' : $t('pages.markupGlobal.inactive') }}
            </span>
            <input
                v-if="editModeActive"
                class="form-control"
                id="globalMarkup"
                v-model="markupInput"
                type="number"
                step="0.01"
                min="-100"
                max="100"
            >
            <small v-if="editModeActive" class="form-text text-muted">
              {{ $t('pages.markupGlobal.help') }}
            </small>

            <div v-if="editModeActive" class="mt-3">
              <button class="btn mt-4 mb-2 btn-success" v-on:click="update">
                {{ $t('common.actions.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      },
      editModeActive: false,
      markupInput: ''
    }
  },
  created() {
    this.showLoader()

    this.$store.dispatch('fetchConfigsEnv')
      .then(() => {
        this.syncInput()
        this.hideLoader()
      })
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
    /*----------------- INPUT SYNC ------------------*/
    syncInput() {
      this.markupInput = (this.configEnv && Number(this.configEnv.globalMarkup))
        ? this.configEnv.globalMarkup
        : ''
    },
    /*----------------- EDIT MODE ------------------*/
    editMode() {
      this.syncInput()
      this.editModeActive = true
    },
    cancelEditMode() {
      this.editModeActive = false

      this.showLoader()

      this.$store.dispatch('fetchConfigsEnv')
        .then(() => {
          this.syncInput()
          this.hideLoader()
        })
    },
    /*----------------- SUBMIT ------------------*/
    update() {
      if (!this.configEnv || !this.configEnv.id) {
        this.$bvToast.toast(this.$t('pages.markupGlobal.editError'), {
          title: this.$t('common.error'),
          variant: 'danger',
          solid: true
        })
        return
      }

      // Champ vidé => désactivation. On envoie 0 (et non null) : le mapping backend
      // utilise isset() qui ignore null, alors que 0 passe le gate ET est traité
      // comme inactif par applyGlobalMarkup (facteur x1).
      const raw = (this.markupInput === '' || this.markupInput === null) ? 0 : Number(this.markupInput)

      // Contrôle de bornes : markup strictement > -100 et <= 100
      if (isNaN(raw) || raw <= -100 || raw > 100) {
        this.$bvToast.toast(this.$t('pages.markupGlobal.invalidValue'), {
          title: this.$t('common.error'),
          variant: 'danger',
          solid: true
        })
        return
      }

      this.editModeActive = false
      this.showLoader()

      const payload = { ...this.configEnv, globalMarkup: raw }

      this.$store.dispatch('updateConfigEnv', { id: this.configEnv.id, configEnv: payload })
        .then(() => {
          return this.$store.dispatch('fetchConfigsEnv')
        })
        .then(() => {
          this.syncInput()
          this.hideLoader()

          this.$bvToast.toast(this.$t('pages.markupGlobal.editSuccess'), {
            title: this.$t('common.success'),
            variant: 'success',
            solid: true
          })
        })
        .catch(() => {
          this.hideLoader()

          this.$bvToast.toast(this.$t('pages.markupGlobal.editError'), {
            title: this.$t('common.error'),
            variant: 'danger',
            solid: true
          })
        })
    }
  },
  computed: {
    ...mapState(['ConfigEnvModule']),
    configEnv() {
      return this.ConfigEnvModule.configsEnv[0]
    }
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
  }
}
</script>

<style scoped>

</style>
